import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { HostBackend } from '../../../Routes/HostBackend.js';
import { PostHeaders } from '../../Admin/Functions/FetchHeaders.js';
import { Fields } from './Fields.js';
import { FormDelete } from './FormDelete.js';
import { MsgBackend } from '../Document/MsgBackend.js';

export const FormUpdate = (props) => {
    const { entity } = useParams();
    const { datas, id } = props;
    const backend = HostBackend();
    const token = sessionStorage.getItem('token');
    const [msg, setMsg] = useState('');

    const handleSubmitUpdate = async (ev) => {
        ev.preventDefault();
        try {
            const inputs = document.getElementById("form-update").elements;
            const params = new URLSearchParams();
            for (let input of inputs) {
                if (input.name && input.value && input.name !== undefined && input.value !== undefined) {
                    params.append(input.name, input.value.toString());
                }
            }
            const formEntries = Object.fromEntries(params.entries());
            const resp = await fetch(`${backend}/admin/update/${entity}`, PostHeaders(token, formEntries)).catch((e) => {
                setMsg({ css: 'bkg-error', msg: e.msg });
            });
            if (resp && resp.ok) {
                setMsg({ css: 'bkg-success', msg: resp.msg })
                setTimeout(window.location = `/admin/entity/collection/${entity}`, 5000);
            }
        } catch (e) {
            setMsg({ css: 'bkg-error', msg: e.message });
        }
    }
    return (
        <div className="admin-form">
            <MsgBackend msg={msg} />
            <FormDelete entity={entity} id={id} />
            <form className="form" id="form-update" onSubmit={handleSubmitUpdate}>
                <fieldset>
                    <legend>{`UPDATE: ${entity}`}</legend>
                    {datas.map((item, i) => {
                        return (
                            <Fields entity={entity} item={item} key={i} />
                        )
                    })}
                    <input className="button" type="submit" defaultValue="Update" />
                </fieldset>
            </form>
            <a className="back" href={`/admin/entity/collection/${entity}`} alt="back" title="back">
                <i className="fa fa-reply"></i>
            </a>
        </div>
    )
}
